import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EparcoursPath } from '../../constantes/menu/menu-items/eparcours-path';
import { FormateursPath } from '../../pages/formateurs/formateurs-path';
import { NavService } from './nav-service';
import { PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class FormateursNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  editionGeneral = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATEURS,
    FormateursPath.EDITION,
    PARAM_TOKEN,
    FormateursPath.EDITION_GENERAL,
  );

  planning = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATEURS,
    FormateursPath.EDITION,
    PARAM_TOKEN,
    FormateursPath.PLANNING,
  );
  // editionMail = this.makeNavigatorWithParam<number>(EparcoursPath.root.FORMATEURS, EparcoursPath.formateurs.EDITION_MAIL);


  taches = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATEURS,
    FormateursPath.EDITION,
    PARAM_TOKEN,
    FormateursPath.TACHES
  )

  documents = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATEURS,
    FormateursPath.EDITION,
    PARAM_TOKEN,
    FormateursPath.DOCUMENTS
  );

  formations = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.FORMATEURS,
    FormateursPath.EDITION,
    PARAM_TOKEN,
    FormateursPath.FORMATIONS
  );

  creation = this.makeNavigator(EparcoursPath.root.FORMATEURS, EparcoursPath.formateurs.CREATION);

  liste = this.makeNavigator(EparcoursPath.root.FORMATEURS);
}
